export default function TermsOfUseIcon({ className = "", onClick = null }) {
  return (
    <svg
      className={`terms-of-use-icon ${className}`}
      onClick={onClick}
      viewBox="0 0 500 500"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M390.18,189.51l-113.7-113.7c-1.16-1.16-2.72-1.81-4.36-1.81H122.31c-7.88,0-14.3,6.41-14.3,14.3v323.41c0,7.88,6.41,14.3,14.3,14.3h255.38c7.88,0,14.3-6.41,14.3-14.3v-217.83c0-1.64-.65-3.2-1.81-4.36ZM262.89,98.67l103.04,103.04h-103.04v-103.04ZM366.21,400.22h-232.42V99.78h103.32v113.43c0,7.87,6.41,14.28,14.28,14.28h114.82v172.73Z"
      />
    </svg>
  );
}
